/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Overview_Success_Dealoverviewmetricremoved4Inputs */

const en_coinvestments_overview_success_dealoverviewmetricremoved4 = /** @type {(inputs: Coinvestments_Overview_Success_Dealoverviewmetricremoved4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metric removed successfully`)
};

/**
* | output |
* | --- |
* | "Metric removed successfully" |
*
* @param {Coinvestments_Overview_Success_Dealoverviewmetricremoved4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_overview_success_dealoverviewmetricremoved4 = /** @type {((inputs?: Coinvestments_Overview_Success_Dealoverviewmetricremoved4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Overview_Success_Dealoverviewmetricremoved4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_overview_success_dealoverviewmetricremoved4(inputs)
});
export { coinvestments_overview_success_dealoverviewmetricremoved4 as "coInvestments_overview_success_dealOverviewMetricRemoved" }